export default "__VITE_ASSET__DxAHadho__"